import { COUNTRY } from 'config/api-routes';
import { Country } from 'config/types';
import { GET } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export type ApiCountry = {
  code: Country;
  currency: string;
  currencySymbol: string;
  domain: string;
};

export default class CountryService {
  async getAvailableCountries(opts = {}): Promise<{ countries: ApiCountry[] }> {
    const response = await GET(COUNTRY.LIST.GET(), opts);

    return formatResponse(response);
  }
}
